import React from "react";
import { CalendarDays, MapPin, BookOpen } from "lucide-react";

const App = () => {
  return (
    <>
      <style>{`
        html, body {
          margin: 0;
          padding: 0;
          overflow: hidden;
          height: 100%;
        }

        @keyframes floatBackground {
          0%   { transform: scale(1.2) translateY(0px); }
          50%  { transform: scale(1.2) translateY(-50px); }
          100% { transform: scale(1.2) translateY(0px); }
        }

        @media (max-width: 600px) {
          .content-container {
            padding: 1.5rem;
          }

          .calendar-btn {
            font-size: 1rem !important;
            padding: 0.8em 1.8em !important;
          }
        }
      `}</style>

      <div
        style={{
          position: "relative",
          width: "100vw",
          height: "100dvh",
          overflow: "hidden",
          fontFamily: "Inter, sans-serif",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Background */}
        <div
          style={{
            backgroundImage: 'url("/bg.jpg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 0,
            animation: "floatBackground 30s ease-in-out infinite",
            willChange: "transform",
          }}
        />

        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.2)",
            backdropFilter: "blur(2px)",
            zIndex: 1,
          }}
        />

        {/* Content */}
        <div
          className="content-container"
          style={{
            position: "relative",
            zIndex: 2,
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "2rem",
            textAlign: "center",
            color: "#fff",
            minHeight: 0,
          }}
        >
          <img
            src="/logo.webp"
            alt="SPW2026 Logo"
            style={{
              width: "min(420px, 90%)",
              marginBottom: "1.8rem",
              filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.4))",
            }}
          />

          <p
            style={{
              fontSize: "clamp(1.1rem, 2vw, 1.5rem)",
              fontWeight: 400,
              marginBottom: "1.8rem",
              maxWidth: 640,
              color: "#fff",
              lineHeight: 1.5,
            }}
          >
            Join the international{" "}
            <strong style={{ fontSize: "clamp(1.2rem, 2.2vw, 1.6rem)" }}>
              Single Photon Workshop 2026
            </strong>{" "}
            in Naples,<br />
            from <strong>July 6 to 10, 2026</strong> — the leading event on quantum photonics.
          </p>

          <h1
            style={{
              fontSize: "clamp(2.2rem, 5vw, 3rem)",
              fontWeight: "700",
              marginBottom: "1.2rem",
              background: "linear-gradient(to right, #f7941d, #f9f871)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            SAVE THE DATE!
          </h1>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1.2rem",
              fontSize: "clamp(0.9rem, 1.5vw, 1rem)",
              marginBottom: "2.2rem",
              flexWrap: "wrap",
              justifyContent: "center",
              color: "#fff",
              textAlign: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
              <CalendarDays size={20} />
              <span>6 – 10 July 2026</span>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
              <MapPin size={20} />
              <span>Naples, Italy</span>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
              <BookOpen size={20} />
              <span>University of Naples Federico II – Campus S. Giovanni</span>
            </div>
          </div>

          <a
            href="/spw2026.ics"
            download="SPW2026.ics"
            className="calendar-btn"
            style={{
              background: "linear-gradient(135deg, #ea9529, #da2422)",
              color: "#fff",
              padding: "1em 2.2em",
              borderRadius: "999px",
              fontSize: "1.1rem",
              textDecoration: "none",
              display: "inline-flex",
              alignItems: "center",
              gap: "0.6rem",
              boxShadow: "0 8px 20px rgba(0, 0, 0, 0.25)",
              transition: "transform 0.3s ease-in-out",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1.0)")}
          >
            <CalendarDays size={22} />
            Add to Calendar
          </a>
        </div>

        {/* Footer */}
        <footer
          style={{
            position: "relative",
            zIndex: 2,
            width: "100%",
            padding: "1rem 1.5rem",
            textAlign: "center",
            color: "#ccc",
            fontSize: "0.9rem",
            background: "linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3))",
            backdropFilter: "blur(2px)",
            boxSizing: "border-box",
            flexShrink: 0,
          }}
        >
          <a
            href="mailto:info@spw2026.org"
            style={{
              color: "#fff",
              textDecoration: "underline",
              fontSize: "1rem",
              display: "inline-block",
            }}
          >
            Contact us
          </a>
        </footer>
      </div>
    </>
  );
};

export default App;
